import React from 'react';
import { Button } from 'react-bootstrap';

interface FilterActionsProps {
    onSearch: () => void;
    onClear: () => void;
    hasActiveFilters: boolean;
    className?: string;
}

export function FilterActions({ onSearch, onClear, hasActiveFilters, className = 'mt-4' }: FilterActionsProps) {
    return (
        <div className={`${className} d-flex`} style={{ gap: '12px' }}>
            <Button onClick={onSearch} style={{ width: 'fit-content' }}>
                Search
            </Button>
            {hasActiveFilters && (
                <Button variant="outline-primary" onClick={onClear} style={{ width: 'fit-content' }}>
                    Clear filters
                </Button>
            )}
        </div>
    );
}
